module.exports = __webpack_public_path__ + "static/Q3_2023_Announcement_Financial_Results-ee7e514a8ae85a948c8078a896e003cc.pdf";